










import { Component, Vue } from 'vue-property-decorator';
import MainLayout from '@/layouts/Main.vue';
import StAndrewsLogo from '@/assets/img/logo_final_gold_no_title.svg';

@Component({
  components: {
    StAndrewsLogo,
  },
})
export default class NotFound extends Vue {
  private goToDashboard() {
    this.$router.push({ name: 'dashboard' });
  }
}
